import React from "react";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";

export default function GeneralCustomer(props) {

  const { setName, defaultvalue, setEmail, email, setPhoneHandler, phone, code, setUser, customerList, validator, user, validateFlag } = props;

  return (
    <div className="card-body">
      <div className="row">
        <div className="mb-3 col-3">
          <label className="form-label">Customer Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Customer Name"
            name="customer_name"
            onChange={(e) => setName(e.target.value)}
            value={defaultvalue}
          />
          {!validateFlag.requote && validator.current.message(
            "Customer Name",
            defaultvalue,
            "required",
            { className: "text-danger text-capitalize" }
          )}
        </div>
        <div className="mb-3 col-3">
          <label className="form-label">Customer Email</label>
          <input
            className="form-control"
            type="email"
            placeholder="Enter Customer Email"
            name="customer_email"
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
          {validator.current.message(
            "Customer Email",
            email,
            "required",
            { className: "text-danger text-capitalize" }
          )}
        </div>
        <div className="mb-3 col-3">
          <label className="form-label">Customer Number</label>
          <PhoneInput
            className="telinput"
            country={"ae"}
            enableSearch
            enableAreaCodes={true}
            onChange={(phone, f, g) => setPhoneHandler(phone, g)}
            value={code + phone}
          />
          {validator.current.message(
            "Customer Number",
            phone,
            "required",
            { className: "text-danger text-capitalize" }
          )}
        </div>

        <div className="mb-3 col-3">
          <label className="form-label">Customer Type</label>
          <Select
            options={customerList}
            styles={{
              valueContainer: (provided) => ({
                ...provided,
                height: "calc(2.15rem + 2px)",
                overflowY: "visible",
              }),
              control: (provider) => ({
                ...provider,
                borderColor: "#d8dbe0",
                boxShadow: "0 0 0 0px #d8dbe0",
              }),
              placeholder: (provider) => ({
                ...provider,
                color: "#d8dbe0",
              }),
            }}
            // eslint-disable-next-line
            value={customerList.find((item) => {
              if (item.value === user?.value) {
                return item;
              }
            })}
            onChange={(e) => setUser(e)}
          />
          {validator.current.message(
            "Customer Type",
            user,
            "required",
            { className: "text-danger text-capitalize" }
          )}
        </div>
      </div>
    </div>
  )

}